export default __webpack_public_path__ + "static/media/hallway.66a68f19.webp";